import { isDefaultBrand, useConfig } from '@travelwin/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NavItem } from '../interfaces/NavBar';
import { isRemix } from '../utils/ssrUtils';
import { getPathnameWithLocale } from '../utils/urlUtils';
import { useExternalHomepageConfig } from './useExternalHomepageConfig';
import { useLocaleUtils } from './useLocaleUtils';

export const useHelpItems = () => {
  const { WHITELABEL_BRAND } = useConfig();
  const { t } = useTranslation();
  const { getHomepageUrl, getLocalizedZendeskUrl } =
    useExternalHomepageConfig();
  const { currentLocale } = useLocaleUtils();

  const helpItem: NavItem = useMemo(
    () => ({
      id: '300',
      label: t('navbar.help', 'Help'),
      visible: isDefaultBrand(WHITELABEL_BRAND),
      'data-testid': 'link-help',
      items: [
        {
          id: '301',
          label: t('navbar.faqs', 'Help Centre'),
          to: getLocalizedZendeskUrl(),
          visible: true,
        },
        {
          id: '302',
          label: t('navbar.store_location', 'Find a Store'),
          to: isRemix()
            ? getPathnameWithLocale('/store-locations', currentLocale)
            : getHomepageUrl('/store-locations'),
          visible: true,
        },
        {
          id: '303',
          label: t('navbar.esim_travel', 'Travel eSIM Explained'),
          to: getHomepageUrl('/travel-esim'),
          visible: true,
        },
        {
          id: '304',
          label: t('navbar.activation_guide', 'eSIM Activation Guides'),
          to: getHomepageUrl('/support/esim-activation-guide'),
          visible: true,
        },
        {
          id: '305',
          label: t('navbar.compatible_handsets', 'eSIM Compatible Phones'),
          to: getHomepageUrl('/support/compatible-handsets'),
          visible: true,
        },
        {
          id: '306',
          label: t('navbar.phone_unlocking', 'Phone Unlocking'),
          to: getHomepageUrl('/support/phone-unlocking'),
          visible: true,
        },
        {
          id: '307',
          label: t('navbar.contact_us', 'Customer Support'),
          to: isRemix()
            ? getPathnameWithLocale('/contact-us', currentLocale)
            : '/contact-us',
          visible: true,
        },
      ],
    }),
    [
      t,
      WHITELABEL_BRAND,
      getHomepageUrl,
      getLocalizedZendeskUrl,
      getPathnameWithLocale,
    ],
  );

  return helpItem;
};
